import React from 'react';
import { stringify } from 'qs'
import {
  useHistory
} from "react-router-dom";
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Pagination from '@material-ui/lab/Pagination';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import CircularProgress from '@material-ui/core/CircularProgress';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { Close } from '@material-ui/icons';
import Snackbar from '@material-ui/core/Snackbar';

import Config from '../config';
import { Divider } from '@material-ui/core';
import AdminHeaderDrawer from '../AdminHeaderDrawer';

moment.locale('au');

interface CustomerRegister {
  firstName?: string;
  lastName?: string;
  mobile?: string;
  email?: string;
  storeId?: string;
  uuid: string;
  createdAt: string;
}

interface FetchCustomerRegisterParams {
  storeId: string;
  pageIdx: number;
  pageSize: number;
  registerDateFrom: string;
  registerDateTo: string;
}

const PAGESIZE: number = 50;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: 'relative',
  },
  container: {
    marginTop: 60,
    marginBottom: 20
  },
  card: {
    minWidth: 275,
    marginBottom: 12,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    // color: 'white',
  },
  wraper: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 10,
    paddingBottom: 10,
  },
  pagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
  center: {
    width: '100%',
    height: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  pos: {
    fontSize: 14,
    color: '#666',
    paddingBottom: 5,
  },
  avatar: {
    backgroundColor: '#999',
  },
  cardContent: {
    paddingBottom: 10,
    paddingTop: 10,
    '&:last-child': {
      paddingBottom: 14,
    },
    textAlign: 'center'
  },
  name: {
    fontSize: 26,
    paddingTop: 5,
    paddingBottom: 10,
  },
  cardHeader: {
    backgroundColor: '',
    textAlign: 'center',
    padding: 10,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between'

  }
}));

const RegisiterRecord = () => {
  const classes = useStyles();
  const history = useHistory();
  const [records, setRecords] = React.useState<CustomerRegister[]>([]);
  const [totalCount, setTotalCount] = React.useState<number>(0);
  const [fetching, setFetching] = React.useState<boolean>(true);
  const [pageIdx, setPageIdx] = React.useState<number>(0);
  const [date, setDate] = React.useState<moment.Moment>(moment());
  const [snackbarOpen, setSnackbarOpen] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>();

  React.useEffect(() => {
    if (!localStorage.getItem('accessToken') || !localStorage.getItem('storeId')) history.push('/login');
    fetchRegisiterRecords(0, date);
  }, []);

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handlePagination = (e: any, value: number) => {
    setPageIdx(value - 1);
    fetchRegisiterRecords(value - 1, date);
  };


  const fetchRegisiterRecords = async (p_pageIdx: number, p_date: moment.Moment) => {
    try {
      setFetching(true);
      const urlParams: FetchCustomerRegisterParams = {
        storeId: localStorage.getItem('storeId') || '',
        pageIdx: p_pageIdx,
        pageSize: PAGESIZE,
        registerDateFrom: moment(p_date).startOf('day')
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),
        registerDateTo: moment(p_date).endOf('day')
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),

      }
      const res = await fetch(`${Config.apiUrl}store/v3/customer/register?${stringify(urlParams)}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('accessToken') || '',
          },
        }
      );
      if (!res.ok) {
        const message = `An error has occured: ${res.status}`;
        throw new Error(message);
      }
      const result = await res.json();
      setRecords(result.records);
      setTotalCount(result.totalCount);

    } catch (error) {
      console.error(error.message)
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    } finally {
      setFetching(false);
    }
  };

  const handleDateChange = (date: any) => {
    setDate(moment(date));
    setPageIdx(0);
    setTotalCount(0);
    setRecords([]);
    fetchRegisiterRecords(0, moment(date));
  };


  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar>
          <AdminHeaderDrawer />
          <Typography variant="h6" className={classes.title}>
            Regisiter Records
          </Typography>
        </Toolbar>
      </AppBar>
      <Container className={classes.container}>
        <div className={classes.header}>
          <Typography variant="body2" style={{ color: '#666', position: 'relative', bottom: 12 }}>
            Total: {totalCount}
          </Typography>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              margin="normal"
              id="date-picker-dialog"
              label="Select Date"
              format="dd/MM/yyyy"
              value={date}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              minDate={moment().subtract(365, 'days')}
              maxDate={moment()}
              style={{ width: 180 }}
            />
          </MuiPickersUtilsProvider>
        </div>

        {fetching && <div className={classes.center}><CircularProgress color="primary" /></div>}
        {(!fetching && records.length > 0) &&
          <React.Fragment>

            <div className={classes.wraper}>
              {records.map((i) => <Card key={i.uuid} className={classes.card} variant="outlined">
                <CardContent className={classes.cardContent}>
                  <Typography className={classes.pos} variant="body1">
                    {moment(i.createdAt).format('LLLL')}
                  </Typography>
                  <Divider />
                  <Typography className={classes.name} variant="h6">
                    {`${i.firstName} ${i.lastName}`}
                  </Typography>
                  <Typography className={classes.pos} variant="body2" color="textSecondary">
                    {i.mobile}
                  </Typography>
                  <Typography className={classes.pos} variant="body2" color="textSecondary">
                    {i.email}
                  </Typography>
                </CardContent>

              </Card>)}
            </div>
            <div className={classes.pagination}>
              <Pagination page={pageIdx + 1} count={Math.ceil(totalCount / PAGESIZE)} onChange={handlePagination} />
            </div>
          </React.Fragment>
        }
        {(!fetching && records.length === 0) && <div className={classes.center}><Typography variant="body2" color="textSecondary">No Data</Typography></div>}
      </Container>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        message={errorMessage}
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={() => setSnackbarOpen(false)}>
              <Close fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </div>
  );
};

export default RegisiterRecord;